// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_gE","advertCardFooter__row":"c-a_gF","advertCardFooter__name":"c-a_gG","advertCardFooter__price":"c-a_gH","advertCardFooter__age":"c-a_gJ"};